<template>
  <div class="newHea">
    <common-nav
      :userInfo="user"
      :msgCount="unReadMsg"
      :ossUrl="ossUrl"
      :baseUrl="baseUrl"
      introLS="complete"
      isOldZhulogic
      :redirect="redirect"
      :filePolicy="filePolicy"
      :fileType="3"
      :VUE_APP_COOKIE_DOMAIN="VUE_APP_COOKIE_DOMAIN"
      thisUrl="next"
      :stageUrl="VUE_APP_STAGE_BASIC_URL"
      @openUserUpload="openUserUploadHandle"
      @authentication="authentication"
      @signinHandle="signin"
      @exit="exitHandle"
      @search="handleSearch"
      :isToken="isToken"
    ></common-nav>
    <contactBox ref="box"></contactBox>
    <egglack-box ref="egglack" :type="2"></egglack-box>
    <egglack-box
      ref="egglackCC"
      text="恭喜你成为住逻辑认证设计师"
      :type="4"
    ></egglack-box>
    <user-upload v-if="isLogin && user" ref="userUpload"></user-upload>
    <egglack-box ref="egglackCC" :type="dialogType2"></egglack-box>
  </div>
</template>
<script>
import api from "../../../../src/api/index";
import util from "../../../../src/libs/util.js";
import { token } from "../../../../src/libs/auth-login.js";
import vueDropdown from "vue-dropdown";
import Store from "../../../../src/store";
import contactBox from "../../../../src/components/common/contactBox.vue";
import egglackBox from "../../../../src/components/common/eggLack.vue";
import triangle from "../../../../src/components/common/triangle.vue";
import searchBox from "../../../../src/components/common/searchBox.vue";
import rightNav from "../../../../src/components/common/rightNav.vue";
import UserUpload from "../../../../src/components/common/my-user-upload";
import "vue2-animate/dist/vue2-animate.min.css";
import CommonNav from "../../../../packages/components/nav/nav.vue";
import Cookie from "js-cookie";
export default {
  // /pass/${this.$router.currentRoute.fullPath}
  name: "newHea",
  data() {
    return {
      redirect: "/#nuxt",
      VUE_APP_COOKIE_DOMAIN: process.env.VUE_APP_COOKIE_DOMAIN,
      VUE_APP_STAGE_BASIC_URL: process.env.VUE_APP_STAGE_BASIC_URL,
      baseUrl: {
        baseOld: process.env.VUE_APP_OLD_BASIC_URL,
        baseNext: process.env.VUE_APP_NEXT_BASIC_URL,
        baseNuxt: process.env.VUE_APP_NUXT_BASIC_URL,
      },
      ossUrl: process.env.VUE_APP_IMAGE_BASE_URL,
      routerArray: [
        "planList",
        "productList",
        "inspirationList",
        "homePage",
        "searchProducts",
        "searchPlans",
        "searchInspirations",
      ],
      isSearchRouter: false,
      isOpenSearch: false,
      isAnmiteShow: 0,
      targetShow: "",
      searchKeyword: "",
      homeMaterialData: [],
      dialogType2: 3,
      filePolicy: "",
      isToken: false,
    };
  },
  components: {
    contactBox,
    vueDropdown,
    egglackBox,
    triangle,
    searchBox,
    rightNav,
    UserUpload,
    CommonNav,
  },
  computed: {
    isLogin() {
      return token();
    },
    user() {
      return this.$store.state.user.info;
    },
    scrollRoll() {
      return this.$store.state.app.scrollRollData;
    },
    unReadMsg() {
      return this.$store.state.user.msgCount;
    },
  },
  methods: {
    async getOssKey(type) {
      api.files.uploadUrl(type).then((res) => {
        this.filePolicy = res;
      });
    },

    checkSearchRouter(router) {
      this.isSearchRouter = this.routerArray.includes(router);
    },
    //监听滚动的事件
    rollHandel() {
      let that = this;
      window.onscroll = function () {
        if (!that.isSearchRouter) {
          return;
        }
        //变量t是滚动条滚动时，距离顶部的距离
        let t = document.documentElement.scrollTop || document.body.scrollTop;
        if (t >= 100) {
          that.$store.dispatch("scrollRoll", true);
        } else {
          that.$store.dispatch("scrollRoll", false);
        }
      };
    },
    homeMaterial() {
      api.homePage.page_down().then((res) => {
        this.homeMaterialData = res;
      });
    },
    showDialog() {
      if (!this.user) {
        return;
      }
      if (this.user.type === 1 && this.user.hasRead === 0) {
        this.$refs.egglack.open("gotoReginer");
      }
      if (
        (this.user.type === 2 || this.user.type === 3) &&
        this.user.hasRead === 0
      ) {
        this.$refs.egglackCC.open("gotoReginer");
      }
    },
    openUserUpload(type) {
      if (!this.isLogin) {
        this.$store.dispatch("getUser");
        return;
      }
      if (
        this.user.type === 2 ||
        this.user.type === 3 ||
        this.user.isVip === 1
      ) {
        this.$refs.userUpload.open(type);
      } else {
        //跳转到认证页面
        this.$refs.egglackCC.open();
      }
    },
    // 认证authentication
    authentication() {
      this.$router.push({ path: "/my/personal/accountSetting" });
    },
    onloadOpenUuload() {
      if (this.$route.query.upload) {
        window.setTimeout(() => {
          this.$route.query.upload === "inspiration" && this.openUserUpload(1);
          this.$route.query.upload === "product" && this.openUserUpload(2);
        }, 1000);
      }
    },
    // 打开上传灵感源和单品的弹框
    openUserUploadHandle(name) {
      let type = Number(name);
      this.openUserUpload(type);
    },
    // 退出登录
    exitHandle() {
      this.$store.dispatch("clearToken");
      this.$router.replace({ path: "/home/homepage" });
      util.setCookie("CountDown", "", -1);
      this.$router.go(0);
      this.isToken = Cookie.get("ZHULOGIC_TOKEN") ? true : false;
    },

    // 签到
    signin() {
      api.account.signin().then((res) => {
        if (res) {
          this.$Message.success("签到领蛋成功");
          this.$store.dispatch("getUser");
        }
      });
    },

    // 全局搜索
    handleSearch(val) {
      window.location = `${this.baseUrl.baseNuxt}/search?keyword=${val}`;
    },
  },
  watch: {
    $route: function (to, from) {
      this.$store.dispatch("scrollRoll", false);
      this.checkSearchRouter(to.name);
      this.isLogin && this.$store.dispatch("getUser");
    },
  },
  mounted() {
    this.onloadOpenUuload();
  },
  created() {
    this.checkSearchRouter(this.$route.name);
    this.isLogin && this.$store.dispatch("getUser");
    this.$store.dispatch("getColors");
    this.$store.dispatch("getStyles");
    this.$store.dispatch("getCategories");
    this.$store.dispatch("getSorts");
    this.$store.dispatch("getRoomTypes");
    this.$store.dispatch("imgSearch", 0);
    this.$store.dispatch("getAddress");
    this.rollHandel();
    this.homeMaterial();
    this.isLogin && this.showDialog();
    this.getOssKey(3);
    this.isToken = Cookie.get("ZHULOGIC_TOKEN") ? true : false;
  },
};
</script>

<style lang="scss">
.zNav .zNav-content .zNav-right .zNav-right-item button .icon-dingdan2 {
  margin-top: -5px !important;
}
</style>
